import React from 'react';
import { FicheBar } from '@mairistem/fiche';

import { toast } from 'react-toastify';
import { Mouvement, useUploadPjs } from '@mairistem/comptabilite';
import { isNewIdentifiant } from '@mairistem/tools';
import CODE_BHM from '../../../constants/mouvements/codeBHM';
import { getDefaultDelaiPaiement } from '../FichePanel/Complements/DelaiPaiement/delaiPaiementUtils';

interface MouvementFicheBarConsumerProps extends React.HTMLAttributes<HTMLElement> {
  identifiant?: number | string;
  onChange?: any;
  onSaved?: any;
  piece?: Mouvement;
  [x: string]: any;
}

const MouvementFicheBarConsumer = ({
  identifiant,
  onChange,
  onSaved,
  piece,
  ...rest
}: MouvementFicheBarConsumerProps) => {
  const uploadPjs = useUploadPjs();

  const handleCanceling = (data) => {
    onChange?.({
      identifiant,
      lignes: data?.lignes?.filter((ligne) => !isNewIdentifiant(ligne?.identifiant)),
    });

    return true;
  };

  const handleSaving = (data) => {
    // Mise a jour de la valeur defaultCodeProfilEcriture
    const newData = {
      ...data,
      identifiant,
    };
    delete newData?.defaultCodeProfilEcriture;
    return newData;
  };

  /**
   * Permet à la création d'un nouveau mouvement de mettre des infos du mouvement précédent.
   * @returns Object
   */
  const handleCreating = (): boolean | Partial<Mouvement> => {
    if (piece.codeBHM === CODE_BHM.VALUE.HISTORISE) {
      toast.info('Impossible de créer une nouvelle pièce depuis une pièce historisée.');
      return false;
    }

    return ({
      codeBHM: piece.codeBHM,
      codeProfilEcriture: piece.codeProfilEcriture,
      ...getDefaultDelaiPaiement(
        piece.exercice,
        piece.tiers,
      ),
      exercice: piece.exercice,
      identifiantBordereau: piece.identifiantBordereau,
      identifiantEntite: piece.identifiantEntite,
      identifiantExercice: piece?.identifiantExercice,
      sens: piece.sens,
      bordereau: piece.bordereau,
      typePiece: piece.typePiece,
      naturePiece: piece.naturePiece,
    });
  };

  const handleSaved = async (data, status) => {
    onSaved?.(data, status);
    await uploadPjs(data?.identifiant);
  };

  return (
    <FicheBar
      {...rest}
      identifiant={identifiant}
      key="MouvementFiche"
      onCanceling={handleCanceling}
      onCreating={handleCreating}
      onSaved={handleSaved}
      onSaving={handleSaving}
      type="piece"
    />
  );
};

export default MouvementFicheBarConsumer;
